const footerColumns = [
  {
    id: "col-1",
    title: "栏目导航",
    links: [
      { label: "最新拉片", href: "#feed" },
      { label: "分析维度", href: "#dimensions" },
      { label: "话题墙", href: "#topics" },
      { label: "背景疑点", href: "#suspicions" },
    ],
  },
  {
    id: "col-2",
    title: "拆解方向",
    links: [
      { label: "逐帧画面", href: "#dimensions" },
      { label: "声音识别", href: "#dimensions" },
      { label: "背景信息", href: "#dimensions" },
      { label: "时间线重建", href: "#dimensions" },
    ],
  },
  {
    id: "col-3",
    title: "使用说明",
    links: [
      { label: "分析方法论", href: "#method" },
      { label: "置信度说明", href: "#method" },
      { label: "常见问题", href: "#faq" },
      { label: "素材补充", href: "#faq" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900">
      <div className="px-4 md:px-6">
        <div className="max-w-6xl mx-auto py-12 md:py-14">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-10">
            <div className="lg:col-span-2">
              <div className="flex items-center gap-2.5">
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-scan-2-line text-lg leading-none"></i>
                </span>
                <span className="font-heading font-bold text-lg text-background-50 tracking-wide">
                  黑料视频
                </span>
              </div>
              <p className="mt-4 text-background-200/80 text-sm leading-relaxed max-w-md">
                面向视频细节分析的资讯聚合门户。把逐帧画面、声音识别与背景信息疑点拆开列好，
                按时间码顺序看线索，拉片和查小破绽都不用再绕路。
              </p>
              <div className="mt-5 flex items-center gap-3">
                <a
                  href="#feed"
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 text-background-100 cursor-pointer hover:bg-background-50/20 transition-colors"
                  aria-label="查看最新拉片"
                >
                  <i className="ri-play-list-2-line text-base leading-none"></i>
                </a>
                <a
                  href="#topics"
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 text-background-100 cursor-pointer hover:bg-background-50/20 transition-colors"
                  aria-label="浏览话题墙"
                >
                  <i className="ri-price-tag-3-line text-base leading-none"></i>
                </a>
                <a
                  href="#faq"
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 text-background-100 cursor-pointer hover:bg-background-50/20 transition-colors"
                  aria-label="查看常见问题"
                >
                  <i className="ri-question-answer-line text-base leading-none"></i>
                </a>
              </div>
            </div>

            {footerColumns.map((col) => (
              <div key={col.id}>
                <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">
                  {col.title}
                </h4>
                <ul className="flex flex-col gap-2.5">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-background-200/75 text-sm whitespace-nowrap cursor-pointer hover:text-background-50 transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
            <p className="text-background-200/70 text-xs md:text-sm">
              © 2026 黑料视频 · 内容仅作公开素材的细节观察与复核交流
            </p>
            <p className="text-background-200/60 text-xs md:text-sm">
              结论附带时间码与置信度，修订记录单独留痕
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}